import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { id: "body-container" }
const _hoisted_2 = { class: "SessionPopup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navbar = _resolveComponent("navbar")!
  const _component_SessionPopup = _resolveComponent("SessionPopup")!
  const _component_sidemenubar = _resolveComponent("sidemenubar")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_navbar, {
      class: _normalizeClass({active:'bg-dark'})
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SessionPopup)
    ]),
    (_ctx.isSessionPopupVisible == true)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["overlay", { active: 'isOverlayActive' }])
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "flex bg-dark",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeApps()))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["z-50", { 'w-40': _ctx.isToggling, 'w-10': !_ctx.isToggling ,active:'bg-dark-blue'}])
      }, [
        _createVNode(_component_sidemenubar)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["content mt-12 flex-1 w-full h-screen overflow-y-scroll pb-12", { toggledstate: _ctx.isToggling }]),
        onScroll: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleScroll($event)))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.nomargincondtion ? 'noMarginBottom':'page')
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 2),
        _createVNode(_component_Footer)
      ], 34)
    ])
  ]))
}